import { mapState } from "vuex";
import FormEditPage from "../../components/FormEditPage";
import CardItem from "@/pages/designCategory/components/CardItem";
import Title from "@/pages/designCategory/components/Title";
import ColorPicker from "@/pages/designCategory/components/ColorPicker";
import FileUpload from "@/pages/designCategory/components/FileUpload";
export default {
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    FormEditPage: FormEditPage,
    CardItem: CardItem,
    Title: Title,
    ColorPicker: ColorPicker,
    FileUpload: FileUpload
  },
  data: function data() {
    return {
      form: this.$form.createForm(this)
    };
  }
};